export const KIND_FIELD = `{
	id: kindId,
	name: kindName,
	code: kindCode
}`

export const TEMPLATE_FIELD = `{
	id: templateId,
	name: templateName
}`

export const PRICING_METHOD_FIELD = `
{
        id: pricingMethodId,
        name: pricingMethodName,
        calcStrategy,
        quantityUnit,
        priceUnit
      
}`
